import { combineReducers } from 'redux'
import languages from './../../data/languages.json'
import countries from './../../data/countries.json'

const initialLanguageState = {
    language: null
}

const initialCountryState = {
    country: null
}

const initialLoadingState = {
    loadingRequired: true,
    autoComplete: false,
}

const initialNotificationShowState = {
    showroom: true,
    car_exterior: true,
    car_interior: true
}

const languageReducer = (state = initialLanguageState, action) => {
    switch (action.type) {
        case 'INIT_LANGUAGE': {
            let language = window.localStorage.getItem("lang_id")
            if (language !== null) {
                let selLang = languages.filter(lg => lg.id === language)
                if (selLang.length > 0) {
                    return {
                        language
                    }
                } else {
                    window.localStorage.removeItem("lang_id")
                    return { ...initialLanguageState }
                }
            } else {
                return { ...initialLanguageState, }
            }
        }
        case 'LANGUAGE_CHANGED': {
            window.localStorage.setItem("lang_id", action.language)
            return {
                ...state,
                language: action.language
            }
        }
        default:
            return state
    }
}

const countryReducer = (state = initialCountryState, action) => {
    switch (action.type) {
        case 'INIT_COUNTRY': {
            let country = window.localStorage.getItem("cntry_id")
            let selCountries = countries.filter(ct => ct.id === country )
            if (selCountries.length > 0) {
                return {
                    country,
                    original: selCountries[0],
                }
            } else {
                if (country !== null) window.localStorage.removeItem("cntry_id")
                return {
                    ...initialCountryState,
                    original: null,
                }
            }
        }
        case 'COUNTRY_CHANGED': {
            window.localStorage.setItem("cntry_id", action.country)
            return {
                ...state,
                country: action.country,
                original: action.original
            }
        }
        default:
            return state
    }
}

const loadingStateReducer = (state = initialLoadingState, action) => {
    switch (action.type) {
        case 'CHANGE_LOADING_REQUIRED': {
            return {
                ...state,
                loadingRequired: action.value
            }
        }
        case 'CHANGE_AUTO_COMPLETED': {
            return {
                ...state,
                autoComplete: action.value
            }
        }
        default:
            return state
    }
}

const notificationReducer = (state = initialNotificationShowState, action) => {
    switch (action.type) {
        case 'CHANGE_SHOWROOM_NOTIFICATION':
            return {
                ...state,
                showroom: action.value
            }
        case 'CHANGE_CAR_NOTIFICATION':
            return {
                ...state,
                [action.inOrEx]: action.value
            }
        default:
            return state
    }
}

const firstLoadReducer = (state = false, action) => {
    switch (action.type) {
        case 'FIRST_LOADED':
            return true
        default:
            return state
    }
}

const webpSupportReducer = (state = null, action) => {
    switch (action.type) {
        case 'CHECKING_WEBP_SUPPORT':
            return state
        case 'CHECKED_WEBP_SUPPORT':
            return action.result
        default:
            return state
    }
}

export default combineReducers({
    languageReducer, countryReducer, loadingStateReducer, notificationReducer, firstLoadReducer, webpSupportReducer
})
